import { useState, useEffect } from 'react';
import { User as FirebaseUser } from 'firebase/auth';
import { subscribeToAuthState } from '../services/auth';

interface UseAuthReturn {
  user: FirebaseUser | null;
  loading: boolean;
  error: Error | null;
}

/**
 * Custom hook to manage authentication state
 * Subscribes to Firebase auth state changes and provides current user
 */
export const useAuth = (): UseAuthReturn => {
  const [user, setUser] = useState<FirebaseUser | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    try {
      // Subscribe to auth state changes
      const unsubscribe = subscribeToAuthState((firebaseUser) => {
        setUser(firebaseUser);
        setLoading(false);
      });

      // Cleanup subscription on unmount
      return () => unsubscribe();
    } catch (err) {
      setError(err instanceof Error ? err : new Error('Failed to subscribe to auth state'));
      setLoading(false);
    }
  }, []);

  return { user, loading, error };
};
